// extracted by mini-css-extract-plugin
export default {"ico_section":"allcoelist_ico_section__0ytNc","img_powerpoint":"allcoelist_img_powerpoint__-i0F2","card_title":"allcoelist_card_title__e0VAc"};